module.exports = __webpack_public_path__ + "static/41-0e10efefeca95bc3382494692a9b2d2b.png";